export const UserRoles = {
    AdministratorSkynet: 1,
    AOLeads: 3,
    InternalInfo: 4,
    AOSales: 5,
    SMBSales: 6,
    Discounts: 7,
    Spcs: 9,
    EmailTemplate: 10,
    Compensation: 11,
    PartnerSales: 12,
    User: 13,
    ProductOverview: 14,
    Eloqua: 15,
    BokaMera: 16,
    OrderApproval: 17,
    SpcsSales: 18,
    Movie: 19,
    CustomerNumber: 20,
    Invoicing: 21,
    SubscriptionAdmin: 22,
    AOSubscriptionManager: 23,
    InvoiceDate: 24,
    CompanyUser: 25,
    PackageManager: 26,
    CollaborationManager: 27,
    DowngradeAdmin: 28,
    OrderForOther: 29,
    OrganizationNumber: 30,
    InvoiceReceiver: 31,
    BankruptcyTermination: 32,
    PriceSimulation: 33,
    PriceReviewer: 34
}

export const Access = {
    ReadOnly: 1,
    ReadWrite: 2,
    Admin: 3
}

export const RoleAccessDescriptions = {
    AOLeads: {
        [Access.ReadOnly]: "",
        [Access.ReadWrite]: "Behörighet att administrera AO Leads som är skickade internt",
        [Access.Admin]: ""
    },
    InternalInfo: {
        [Access.ReadOnly]: "",
        [Access.ReadWrite]: "",
        [Access.Admin]: "Redigera kreditgräns, fakturaavgift, spcs edi, och betalningsvillkor."
    },
    AOSales: {
        [Access.ReadOnly]: "Tillgång till kundregistret",
        [Access.ReadWrite]: "Lägga ordrar på byråer med paketlösningar. Redigera kundinformation",
        [Access.Admin]: "Redigera de byråer som visas för Hitta Byrå kartan"
    },
    SMBSales: {
        [Access.ReadOnly]: "",
        [Access.ReadWrite]: "Används för säljare på företagsförsäljningen för att sätta fakturans startdatum vid orderläggning",
        [Access.Admin]: ""
    },
    Discounts: {
        [Access.ReadOnly]: "",
        [Access.ReadWrite]: "",
        [Access.Admin]: "Lägga till, redigera och ta bort VON rabattavtal"
    },
    Spcs: {
        [Access.ReadOnly]: "Behörighet att kunna se och använda Spcs specifika delar av Skynet",
        [Access.ReadWrite]: "Skicka mejl, hantera interna leads",
        [Access.Admin]: "Ändra kundinformationstyper. Hantera budget för användare samt teams"
    },
    EmailTemplate: {
        [Access.ReadOnly]: "",
        [Access.ReadWrite]: "",
        [Access.Admin]: "Redigera e-post mallar"
    },
    Compensation: {
        [Access.ReadOnly]: "",
        [Access.ReadWrite]: "",
        [Access.Admin]: "Redigera skickade kompensationer"
    },
    PartnerSales: {
        [Access.ReadOnly]: "",
        [Access.ReadWrite]: "",
        [Access.Admin]: "Redigera de partners som visas för Hitta Partner kartan"
    },
    User: {
        [Access.ReadOnly]: "",
        [Access.ReadWrite]: "",
        [Access.Admin]: "Hantera användarbehörigheter"
    },
    ProductOverview: {
        [Access.ReadOnly]: "",
        [Access.ReadWrite]: "",
        [Access.Admin]: "Redigera produkter samt produktversioner för produktöversikten "
    },
    Eloqua: {
        [Access.ReadOnly]: "",
        [Access.ReadWrite]: "",
        [Access.Admin]: "Behörighet till Eloquainställningar"
    },
    BokaMera: {
        [Access.ReadOnly]: "",
        [Access.ReadWrite]: "",
        [Access.Admin]: "Köra fakturering för BokaMera ordrar"
    },
    OrderApproval: {
        [Access.ReadOnly]: "",
        [Access.ReadWrite]: "",
        [Access.Admin]: "Godkänna, neka samt kommentera orderläggningar över kreditgränsen"
    },
    SpcsSales: {
        [Access.ReadOnly]: "",
        [Access.ReadWrite]: "Behörighet till order- och offertläggning",
        [Access.Admin]: "Uppdatera orderbekräftelsemallar"
    },
    Movie: {
        [Access.ReadOnly]: "",
        [Access.ReadWrite]: "",
        [Access.Admin]: "Ger behörighet att skapa och redigera filmer"
    },
    CustomerNumber: {
        [Access.ReadOnly]: "",
        [Access.ReadWrite]: "",
        [Access.Admin]: "Ger behörighet att redigera kundnummer på kund"
    },
    Invoicing: {
        [Access.ReadOnly]: "",
        [Access.ReadWrite]: "",
        [Access.Admin]: "Ger behörighet att visa och skapa fakturakörningar"
    },
    SubscriptionAdmin: {
        [Access.ReadOnly]: "",
        [Access.ReadWrite]: "",
        [Access.Admin]: "Ger behörighet att avsluta prenumerationer direkt"
    },
    AOSubscriptionManager: {
        [Access.ReadOnly]: '',
        [Access.ReadWrite]: '',
        [Access.Admin]: 'Ger behörighet att redigera & avsluta prenumerationer för AOs direkt',
    },
    InvoiceDate: {
        [Access.ReadOnly]: "",
        [Access.ReadWrite]: "",
        [Access.Admin]: "Ger behörighet att sätta fakturastart vid orderläggning"
    },
    CompanyUser: {
        [Access.ReadOnly]: "",
        [Access.ReadWrite]: "Ger behörighet att lägga till och hantera företagsanvändare",
        [Access.Admin]: ""
    },
    PackageManager: {
        [Access.ReadOnly]: "",
        [Access.ReadWrite]: "",
        [Access.Admin]: "Ger behörighet att skapa och redigera paket i pakethanteringen"
    },
    CollaborationManager: {
        [Access.ReadOnly]: "",
        [Access.ReadWrite]: "Ger behörighet att avbryta samarbeten.",
        [Access.Admin]: ""
    },
    DowngradeAdmin: {
        [Access.ReadOnly]: "",
        [Access.ReadWrite]: "",
        [Access.Admin]: "Ger behörighet att nedgradera prenumerationer",
    },
    OrderForOther: {
        [Access.ReadOnly]: "",
        [Access.ReadWrite]: "Ger behörighet att välja säljare på en order",
        [Access.Admin]: "",
    },
    OrganizationNumber: {
        [Access.ReadOnly]: "",
        [Access.ReadWrite]: "",
        [Access.Admin]: "Ger behörighet att ändra organisationsnummer på kund",
    },
    InvoiceReceiver: {
        [Access.ReadOnly]: "",
        [Access.ReadWrite]: "",
        [Access.Admin]: "Ger behörighet att ändra faktura kundnummer på kund",
    },
    BankruptcyTermination: {
        [Access.ReadOnly]: "",
        [Access.ReadWrite]: "",
        [Access.Admin]: "Ger behörighet att se hur termineringsjobbet för bolag satta i konkurs har gått",
    },
    PriceSimulation: {
        [Access.ReadOnly]: "",
        [Access.ReadWrite]: "",
        [Access.Admin]: "Ger behörighet att använda prissimuleringsverktyget.",
    },
    PriceReviewer: {
        [Access.ReadOnly]: "",
        [Access.ReadWrite]: "",
        [Access.Admin]: "Ger behörighet att granska prissättningar i prissimuleringsverktyget.",
    }
};
